<template>
  <v-dialog
    :value="show"
    persistent
    max-width="1024"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="false"
    >
      <v-card>
        <v-card-title class="justify-center">
          <v-btn
            :icon="true"
            class="_rating-dialog-close"
            @click="$emit('close')"
          >
            <v-icon
              :size="32"
            >
              mdi-close
            </v-icon>
          </v-btn>
          <v-img
            src="/img/rating/LINE-Character.svg"
            :height="200"
            :width="200"
            :contain="true"
          />
        </v-card-title>
        <v-card-text>
          <p class="text-center _fs-16">
            ทำรายการเสร็จแล้วอย่าพึ่งรีบ รบกวนลูกค้าช่วยให้คะแนน และร่วมแสดง <br />
            ความคิดเห็นเพื่อพัฒนาระบบต่อไปให้หน่อยครับ
          </p>
          <v-rating
            v-model="rating"
            class="d-flex justify-center">
            <template v-slot:item="props">
              <v-img
                :src="getImageRating(props.index, props.isFilled)"
                :max-height="60"
                :max-width="60"
                :contain="true"
                class="_cursor-pointer"
                @click="props.click"
              />
            </template>
          </v-rating>
          <v-textarea
            v-model="description"
            :counter="500"
            :filled="true"
            :no-resize="true"
            background-color="#f4f4f4"
            :rules="[
              (v)=> !!v,
              (v) => v.length <= 500
            ]"
            class="justify-center _rating-description"

          />
        </v-card-text>
        <v-card-actions class="pb-8">
          <v-spacer />
          <v-btn
            color="primary"
            rounded
            min-width="150"
            outlined
            exact
            @click="$emit('close')">
            ยกเลิก
          </v-btn>
          <v-btn
            class="ml-4"
            color="primary"
            rounded
            min-width="150"
            :disabled="!valid || !isFormVaild"
            @click="onSubmit">
            ยืนยัน
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RatingDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: false,
      rating: undefined,
      description: ''
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    }),
    lineUid() {
      return this.userProfile?.uid || null
    },
    isFormVaild() {
      return !!this.rating && !!this.description
    }
  },
  mounted() {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'payment_success',
      category: 'user_action',
      label: 'payment_success',
      value: 1,
      userId: this.lineUid,
      payment_type: this.orderData.payments?.[0]?.type || null,
      premium_id: this.activeLineOfficialAccount.premiumId || null,
      basic_id: this.orderData.basicId || null,
      customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new',
      orderItems: this.orderData.orderItems || [],
      pre_vat_amount: this.orderData.preVatAmount || null,
      vat: this.orderData.vat || null,
      vat_amount: this.orderData.vatAmount || null,
      witholding_tax_amount: this.orderData.withholdingTaxAmount ?? null
    })
  },
  methods: {
    getImageRating(index, isFilled) {
      if (isFilled) {
        switch (index) {
          case 0:
            return '/img/rating/active/LINE-1.svg'
          case 1:
            return '/img/rating/active/LINE-2.svg'
          case 2:
            return '/img/rating/active/LINE-3.svg'
          case 3:
            return '/img/rating/active/LINE-4.svg'
          case 4:
            return '/img/rating/active/LINE-5.svg'
          default:
            return ''
        }
      } else {
        switch (index) {
          case 0:
            return '/img/rating/inactive/LINE-1.1.svg'
          case 1:
            return '/img/rating/inactive/LINE-2.2.svg'
          case 2:
            return '/img/rating/inactive/LINE-3.3.svg'
          case 3:
            return '/img/rating/inactive/LINE-4.4.svg'
          case 4:
            return '/img/rating/inactive/LINE-5.5.svg'
          default:
            return ''
        }
      }
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'click_submit_review_btn',
          category: 'user_action',
          label: 'review_btn_submit',
          value: 1,
          userId: this.lineUid
        })
        this.$emit('submit', {
          rating: this.rating,
          description: this.description
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
._cursor-pointer {
  cursor: pointer;
}

._rating-description {
  max-width: 600px;
  margin: 20px auto 0px auto;
}

._rating-dialog-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
}
</style>
